import { Box, Checkbox, Tooltip } from "@chakra-ui/react"
import { STALE_AFTER_HOURS } from "lib/presence"

// Checkbox "Offline": when checked, only locations with a red warning triangle are shown
// (last ping or last sync missing or older than 4 hours). `count` is how many there are.
export default function OfflineFilter({ isChecked, onChange, count }) {
  return (
    <Tooltip label={`Only locations whose last ping or last sync is missing or older than ${STALE_AFTER_HOURS} hours`}>
      <Box>
        <Checkbox colorScheme='brand' whiteSpace='nowrap' isChecked={isChecked} onChange={e => onChange(e.target.checked)}>
          Offline{count > 0 ? ` (${count})` : ''}
        </Checkbox>
      </Box>
    </Tooltip>
  )
}
